import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '@proximus/ng-common';

@Pipe({
  name: 'chargeFrequency',
})
export class ChargeFrequencyPipe implements PipeTransform {
  constructor(private translationService: TranslationService) {}

  transform(value: any, property?: string): any {
    switch (property ? value && value[property] : value) {
      case 'MON':
        return (
          '/' +
          this.translationService.getTranslatedValueFor('price.frequency.month')
        );
      case 'DAY':
        return (
          '/' +
          this.translationService.getTranslatedValueFor('price.frequency.day')
        );
      case 'YEA':
        return (
          '/' +
          this.translationService.getTranslatedValueFor('price.frequency.year')
        );
      default:
        return undefined;
    }
  }
}
